(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function text(value) {
    return String(value || '').trim();
  }

  function normalize(value) {
    return text(value)
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeHtml(value) {
    return text(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function sortValues(field, values) {
    return values.sort(function (a, b) {
      if (field === 'year') return Number(b) - Number(a);
      return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
    });
  }

  function uniqueValues(records, field) {
    var seen = new Set();
    records.forEach(function (rv) {
      var value = text(rv[field]);
      if (value) seen.add(value);
    });
    return Array.from(seen);
  }

  function displayTitle(rv) {
    return text(rv.display_title) || [rv.year, rv.make, rv.brand, rv.series, rv.model_floorplan].map(text).filter(Boolean).join(' ');
  }

  function normalizeRecord(rv) {
    var record = Object.assign({}, rv || {});

    record.year = text(record.year);
    record.make = text(record.make);
    record.brand = text(record.brand || record.model_name || record.line);
    record.series = text(record.series);
    record.model_floorplan = text(record.model_floorplan || record.floorplan || record.model);
    record.display_title = displayTitle(record);
    record.url = text(record.url || record.published_url || (record.handle ? '/rvs/' + record.handle : ''));
    record.main_bed = text(record.main_bed || record.main_bed_size || record.primary_bed || record.known_main_bed);
    record.recommended_main = text(record.recommended_main || record.main_recommendation || record.recommended_product);
    record.recommended_bunk = text(record.recommended_bunk || record.bunk_recommendation);

    record._search = normalize([
      record.rv_id,
      record.year,
      record.make,
      record.brand,
      record.series,
      record.model_floorplan,
      record.display_title,
      record.main_bed,
      record.recommended_main,
      record.search_text
    ].join(' '));

    return record;
  }

  function getFilterState(root) {
    var state = {};
    root.querySelectorAll('[data-rv-filter]').forEach(function (select) {
      state[select.getAttribute('data-rv-filter')] = select.value;
    });
    state.query = root.querySelector('[data-rv-search]').value;
    return state;
  }

  function filterRecords(records, state, excludeField) {
    var query = normalize(state.query);

    return records.filter(function (rv) {
      if (query && rv._search.indexOf(query) === -1) return false;
      return ['year', 'make', 'brand', 'model_floorplan'].every(function (field) {
        if (field === excludeField) return true;
        return !state[field] || rv[field] === state[field];
      });
    });
  }

  function fillSelect(select, values, currentValue, field) {
    var firstLabel = {
      year: 'Any year',
      make: 'Any make',
      brand: 'Any brand',
      model_floorplan: 'Any model'
    }[field] || 'Any';

    var options = ['<option value="">' + firstLabel + '</option>'];
    sortValues(field, values).forEach(function (value) {
      var selected = value === currentValue ? ' selected' : '';
      options.push('<option value="' + escapeHtml(value) + '"' + selected + '>' + escapeHtml(value) + '</option>');
    });

    select.innerHTML = options.join('');
    if (currentValue && values.indexOf(currentValue) === -1) select.value = '';
  }

  function refreshSelects(root, records) {
    var state = getFilterState(root);

    root.querySelectorAll('[data-rv-filter]').forEach(function (select) {
      var field = select.getAttribute('data-rv-filter');
      var recordsForOptions = filterRecords(records, state, field);
      fillSelect(select, uniqueValues(recordsForOptions, field), state[field], field);
    });
  }

  function resultFacts(rv) {
    var facts = [];
    if (rv.main_bed) facts.push('<li><strong>Main bed:</strong> ' + escapeHtml(rv.main_bed) + '</li>');
    if (rv.recommended_main) facts.push('<li><strong>Main recommendation:</strong> ' + escapeHtml(rv.recommended_main) + '</li>');
    if (rv.recommended_bunk) facts.push('<li><strong>Bunk recommendation:</strong> ' + escapeHtml(rv.recommended_bunk) + '</li>');
    if (rv.has_bunks === true || rv.bunks === true) facts.push('<li><strong>Bunks:</strong> Yes</li>');
    if (!facts.length) facts.push('<li><strong>Fit note:</strong> Confirm platform size before ordering.</li>');
    return facts.join('');
  }

  function renderResults(root, records, totalCount) {
    var resultsEl = root.querySelector('[data-rv-results]');
    var statusEl = root.querySelector('[data-rv-status]');
    var limit = Number(root.getAttribute('data-results-limit')) || 24;
    var visible = records.slice(0, limit);

    if (!records.length) {
      statusEl.textContent = totalCount ? 'No matching RVs found.' : 'No RV records are loaded yet.';
      resultsEl.innerHTML = '<div class="rv-finder__empty"><h2>No matching RV found yet</h2><p>Try searching only the floorplan code, such as 28DBUD, or narrow by year and make. If it is not in the database, use the contact link below.</p></div>';
      return;
    }

    statusEl.textContent = 'Showing ' + visible.length + ' of ' + records.length + ' matching RV' + (records.length === 1 ? '' : 's') + '.';

    resultsEl.innerHTML = visible.map(function (rv) {
      var meta = [rv.year, rv.make, rv.brand, rv.series, rv.model_floorplan].map(text).filter(Boolean).join(' • ');
      var link = rv.url || '#';
      var disabled = rv.url ? '' : ' aria-disabled="true"';

      return '<article class="rv-finder__card">'
        + '<h2>' + escapeHtml(rv.display_title) + '</h2>'
        + (meta ? '<p class="rv-finder__meta">' + escapeHtml(meta) + '</p>' : '')
        + '<ul class="rv-finder__facts">' + resultFacts(rv) + '</ul>'
        + '<a class="rv-finder__card-link" href="' + escapeHtml(link) + '"' + disabled + '>View Mattress Guide</a>'
        + '</article>';
    }).join('');
  }

  function refresh(root, records) {
    var state = getFilterState(root);
    var filtered = filterRecords(records, state);
    refreshSelects(root, records);
    renderResults(root, filtered, records.length);
  }

  function clearDownstream(root, changedField) {
    var order = ['year', 'make', 'brand', 'model_floorplan'];
    var index = order.indexOf(changedField);
    if (index === -1) return;
    order.slice(index + 1).forEach(function (field) {
      var select = root.querySelector('[data-rv-filter="' + field + '"]');
      if (select) select.value = '';
    });
  }

  function initFinder(root) {
    var indexUrl = root.getAttribute('data-index-url');
    var statusEl = root.querySelector('[data-rv-status]');
    var records = [];

    fetch(indexUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not load rv-search-index.json');
        return response.json();
      })
      .then(function (data) {
        records = Array.isArray(data) ? data.map(normalizeRecord).filter(function (rv) {
          return rv.display_title || rv.rv_id;
        }) : [];
        refresh(root, records);
      })
      .catch(function () {
        statusEl.textContent = 'RV database index could not be loaded.';
        renderResults(root, [], 0);
      });

    root.querySelector('[data-rv-search]').addEventListener('input', function () {
      refresh(root, records);
    });

    root.querySelectorAll('[data-rv-filter]').forEach(function (select) {
      select.addEventListener('change', function () {
        clearDownstream(root, select.getAttribute('data-rv-filter'));
        refresh(root, records);
      });
    });

    root.querySelector('[data-rv-clear]').addEventListener('click', function () {
      root.querySelector('[data-rv-search]').value = '';
      root.querySelectorAll('[data-rv-filter]').forEach(function (select) { select.value = ''; });
      refresh(root, records);
    });
  }

  ready(function () {
    document.querySelectorAll('[data-rv-finder]').forEach(initFinder);
  });
})();
